/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { SalesOrder } from '@msdyn365-commerce/retail-proxy';
import { TenderLine } from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import { INodeProps, ITelemetryContent } from '@msdyn365-commerce-modules/utilities';

import { IPriceContext } from './utilities';

export * from './address';
export * from './buy-selected-component';
export * from './expand-button-state';
export * from './get-groups';
export * from './get-order-information';
export * from './get-sales-line';
export * from './get-sales-lines';
export * from './label';
export * from './sales-line-state';
export * from './utilities';

export interface IGetHelpInput {
    needHelpLabel: string;
    helpLineNumberLabel: string;
    contactNumber: string;
    helpLineContactAriaLabel: string;
    telemetryContent?: ITelemetryContent;
}

export interface IHelp {
    helpProps: INodeProps;
    needHelpLabel: React.ReactNode;
    helpLineNumberLabel: React.ReactNode;
    contactNumber: React.ReactNode;
}

export interface IGetOrderSummaryInput {
    order: SalesOrder;
    earnedPoints: number;
    priceContext: IPriceContext;
    resource: {
        orderSummaryItemsTotalLabel: string;
        orderSummaryShippingFeeLabel: string;
        orderSummaryTaxLabel: string;
        orderSummaryGrandTotalLabel: string;
        orderSummaryHeading: string;
        pointsEarnedLabel: string;
    };
    canShip?: boolean;
}

export interface IOrderSummary {
    orderSummaryProps: INodeProps;
    heading: React.ReactNode;
    subtotal: React.ReactNode;
    shipping: React.ReactNode;
    tax: React.ReactNode;
    totalAmount: React.ReactNode;
    earnedPoints?: React.ReactNode;
}

export interface IPaymentMethodsInput {
    priceContext: IPriceContext;
    tenderLines: TenderLine[];
    tenderIdOperationIdMap: object;
    locale: string;
    resource: {
        paymentMethodsTitle: string;
        creditCardEndingLabel: string;
        giftCardEndingLabel: string;
        amountCoveredLabel: string;
        loyaltyCardUsedLabel: string;
        cashUsedLabel: string;
        customerAccountUsedLabel: string;
    };
}

export interface IPaymentMethods {
    paymentMethodsProps: INodeProps;
    title: React.ReactNode;
    methods: React.ReactNode[];
}
